export function getScoreColor(score: number): string {
  if (score >= 85) return 'var(--primary)';
  if (score >= 70) return 'var(--color-blue-500)';
  if (score >= 50) return 'var(--color-gray-400)';
  return 'var(--color-red-500)';
}
